export const paymentTypeColorMapper = {
  one_time: "#d3adf7",
  recurring: "#87d068",
  free: "#2db7f5",
  installments: "#6E56CF",
} as const;
